import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import ContentPrerequisitesQuery, {
	type ContentPrerequisitesQuery$data,
	type ContentPrerequisitesQuery$variables,
} from './__generated__/ContentPrerequisitesQuery.graphql';
import ContentRedirectQuery, {
	type ContentRedirectQuery$data,
	type ContentRedirectQuery$variables,
} from './__generated__/ContentRedirectQuery.graphql';

const preloadContentPrerequisitesQuery = (contentId: string, spaceKey: string | null | undefined) =>
	query<ContentPrerequisitesQuery$data, ContentPrerequisitesQuery$variables>({
		query: ContentPrerequisitesQuery,
		errorPolicy: 'all',
		variables: {
			contentId,
			missingSpaceKey: !spaceKey,
			spaceKey,
		},
	});

const preloadContentRedirectQuery = ({
	contentId,
	versionOverride,
}: PreloadContentRedirectQueryArgs) =>
	query<ContentRedirectQuery$data, ContentRedirectQuery$variables>({
		query: ContentRedirectQuery,
		errorPolicy: 'all',
		variables: {
			contentId,
			versionOverride,
		},
	});

type PreloadContentRedirectQueryArgs = {
	contentId: string;
} & Pick<PreloadContentPrerequisitesNamedArgs, 'versionOverride'>;

export const preloadContentPrerequisites = (
	contentId: string,
	spaceKey: string | null | undefined,
	// Note: Add new function parameters/arguments to namedArgs below please! More than 3-4 unnamed function arguments makes it noticeably harder to comprehend the function calls.
	namedArgs?: PreloadContentPrerequisitesNamedArgs,
) => {
	return waitForAllReturnWhenError([
		preloadContentPrerequisitesQuery(contentId, spaceKey),
		preloadContentRedirectQuery({ contentId, ...namedArgs }),
	]);
};

type PreloadContentPrerequisitesNamedArgs = {
	versionOverride?: number | null;
};
